import { computed, ref } from 'vue'
import { useClipboard } from '@vueuse/core'

import type { ComputedRef, Ref } from 'vue'
import type { BtnLinkIdProps } from '../types/interfaces'

interface BtnLinkIdOptions {
  props: BtnLinkIdProps
}

interface BtnLinkIdReturn {
  refIsSupported: Ref<boolean>
  refTooltipText: ComputedRef<string>
  setCopy: () => void
}

export const useBtnLinkId = ({ props }: BtnLinkIdOptions): BtnLinkIdReturn => {
  const source = ref<string>(props.linkId)
  const { copy, copied, isSupported } = useClipboard({ source })

  const refTooltipText = computed<string>(() => {
    if (copied.value) return 'ID copied'
    return `${props.tooltipText} ${props.linkId}`
  })

  const setCopy = (): void => {
    copy(source.value)
  }

  return {
    refIsSupported: isSupported,
    refTooltipText,
    setCopy,
  }
}
